var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40065 8.16932L10.9946 10.7633L10.4293 11.3293L7.60065 8.50065V4.50065H8.40065V8.16932ZM8.00065 15.1673C4.31865 15.1673 1.33398 12.1827 1.33398 8.50065C1.33398 4.81865 4.31865 1.83398 8.00065 1.83398C11.6827 1.83398 14.6673 4.81865 14.6673 8.50065C14.6673 12.1827 11.6827 15.1673 8.00065 15.1673ZM8.00065 14.3673C9.55659 14.3673 11.0488 13.7492 12.149 12.649C13.2492 11.5488 13.8673 10.0566 13.8673 8.50065C13.8673 6.94471 13.2492 5.4525 12.149 4.35229C11.0488 3.25208 9.55659 2.63398 8.00065 2.63398C6.44471 2.63398 4.9525 3.25208 3.85229 4.35229C2.75208 5.4525 2.13398 6.94471 2.13398 8.50065C2.13398 10.0566 2.75208 11.5488 3.85229 12.649C4.9525 13.7492 6.44471 14.3673 8.00065 14.3673Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.ae487a44dcfaa3cbfed4de538957869c.svg";
export { ForwardRef as ReactComponent };